import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const SalesTargetInput = () => {
  const { targetId = '' } = useParams();
  const decodedId = targetId ? atob(targetId) : targetId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'salesTarget';

  useEffect(() => {
    if (targetId) { setIsEditing(true); fetchDetails(); }
  }, [targetId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['salesTarget'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Sales Target details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"target_amount","label":"Target Amount","type":"number"},{"name":"period","label":"Period","type":"text"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Sales Target' : 'Create Sales Target'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default SalesTargetInput;